import {useFormikContext} from 'formik';
import React, {useCallback, useState} from 'react';
import {Spinner} from 'react-bootstrap';
import {formatFileSize} from 'shared/helpers';
import styled from 'styled-components';

const LogoUpload = ({
    height,
    imgSrc,
    onSaveCallback,
    handleImageClick,
    fileInputRef,
    limit,
}: {
    height?: string;
    imgSrc: string;
    onSaveCallback:
        | ((name: string, value: string, values?: unknown) => void)
        | undefined;
    handleImageClick: () => void;
    fileInputRef: React.RefObject<HTMLInputElement>;
    limit?: number;
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const {values, setFieldError} = useFormikContext<
        Partial<{
            [key: string]: File;
        }>
    >();

    const handleFileChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const file = event.target.files[0];
            if (file) {
                if (limit && file.size > limit) {
                    setFieldError(
                        'uploadedLogo',
                        `Maximum file size is ${formatFileSize(limit)}.`
                    );
                    setIsLoading(false);
                    event.target.value = '';
                } else {
                    onSaveCallback?.('', '', {
                        ...values,
                        uploadedLogo: file,
                    });
                    setIsLoading(true);
                }
            }
        },
        [values, limit, setFieldError, setIsLoading]
    );

    const hideLoader = useCallback(() => {
        setIsLoading(false);
    }, []);

    return (
        <>
            {isLoading ? (
                <LoadingDiv>
                    <Spinner
                        style={{
                            width: '20px',
                            height: '20px',
                        }}
                        animation="border"
                        role="status"
                    />
                </LoadingDiv>
            ) : null}
            <Thumbnail
                src={imgSrc}
                $height={height}
                onClick={handleImageClick}
                onLoad={hideLoader}
                onError={hideLoader}
                style={{display: isLoading ? 'none' : 'block'}}
            />
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{display: 'none'}}
                accept=".gif, .jpg, .jpeg, .png"
            />
        </>
    );
};

const LoadingDiv = styled.div`
    display: flex;
    width: 80px;
    height: 80px;
    justify-content: center;
    align-items: center;
`;

export const Thumbnail = styled.img<{$height?: string}>`
    width: ${({$height}) => (!!$height ? 'unset' : '62px')};
    height: ${({$height, theme}) =>
        theme?.device?.isSmall ? '50px' : $height};
    padding: 5px;
    cursor: pointer;
    background: #fff;
    border-radius: 3px;
    border: 1px solid #e3e6e8;
    &:hover {
        border-color: ${({theme}) => theme.colors.primary.main} !important;
    }
`;

export default LogoUpload;
